var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-wrap"},[_c('div',{staticClass:"banner-wrap pb-5"},[_c('landing-page')],1),_c('recommended-plans',{staticClass:"mt-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }